'use strict';
import angular from 'angular';
import $ from 'jquery';

angular.module('app.services')

    .service('$ioAlert', [ function() {
        this.show = function(title, content, type){
            $.notify(title + ' : ' +content, type, {globalPosition: 'top right'});
        };
        return this;
    }]);